import { DefaultProjectTeamBase } from './base/default-project-team-base';

export class DefaultProjectTeam extends DefaultProjectTeamBase { }